import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Constants } from 'app/utility/constants';
import { Observable } from 'rxjs';

@Pipe({
    name: 'authenticatedImage',
    standalone: false
})
export class AuthenticatedImagePipe implements PipeTransform
{
    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

    transform(src: string)
    {
        return new Observable<string>((observer) =>
        {
            // If the source is empty or a placeholder, return the placeholder image
            if (!src || src === Constants.PlaceholderCarUrl)
            {
                observer.next(Constants.PlaceholderCarUrl);
                observer.complete();
            }
            // If the source is a data URL, return it directly
            else if (src.startsWith('data:'))
            {
                observer.next(src);
                observer.complete();
            }
            // If the image is public (not requiring authentication)
            else if (!src.startsWith(Constants.ApiUrl))
            {
                observer.next(src);
                observer.complete();
            }
            else 
            {
                // Return a placeholder immediately
                observer.next(Constants.NoImageUrl);

                this.http.get(src, { responseType: 'blob' }).subscribe({next: response =>
                {
                    const reader = new FileReader();
                    reader.onloadend = () =>
                    {
                        observer.next(reader.result as string);
                        observer.complete();
                    };
                    reader.onerror = () =>
                    {
                        console.error('Error reading image file:', reader.error);
                        observer.next(Constants.NoImageUrl);
                        observer.complete();
                    };
                    reader.readAsDataURL(response);
                }, error: error =>
                {
                    console.error('Error fetching image:', error);
                    observer.next(Constants.NoImageUrl);
                    observer.complete();
                }});
            }
        });
    }
}
